/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import l10n from '../../shared/strings';
import showBatchOperationStartedToast from '../batchOperations/helpers/showBatchOperationStartedToast';
import { OPERATION_TYPES, RESULT } from '../batchOperations/constants';

const strings = l10n.ACTIONS_TOOLBAR.PRODUCTS;

export const overwriteListingDraftsFromPublished = createAsyncThunk(
  'products/overwriteListingDraftsFromPublished',
  async ({
    productIds = [],
    variantIds = [],
    channelName,
  }, {
    extra: {
      sdk, Toast, Logger,
    },
  }) => {
    try {
      const { data } = await sdk.products.overwriteDraftsFromLive({
        ...(productIds.length ? { productIds } : {}),
        ...(variantIds.length ? { variantIds } : {}),
      });

      if (!data?.batchId) throw new Error('Overwrite drafts batch was not started');

      showBatchOperationStartedToast({
        batchId: data.batchId,
        status: data.status || RESULT.queued,
        total: data.total,
        operationType: OPERATION_TYPES.OVERWRITE_DRAFTS_FROM_LIVE,
        channelName,
      });
      return data;
    } catch (error) {
      Toast(strings.overwriteDraftsFailed, { type: 'error', autoClose: false });
      Logger.error(new Error('Bulk overwrite drafts from published failed'), { error }, [
        'OverwriteListingDraftsFromPublishedFailed',
        { errorMessage: error?.message || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(overwriteListingDraftsFromPublished.rejected, (state, { error }) => {
    state.error = error?.message || 'Cannot overwrite drafts from published records';
  });
};